import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys'
import Typography from '@material-ui/core/Typography'
import { withPrefix } from 'gatsby-link'
import EyeIcon from 'react-icons/lib/fa/eye'
import {
  TwitterShareButton,
  PinterestShareButton,
  FacebookShareButton,
  GooglePlusShareButton,
  TumblrShareButton,
  TwitterIcon,
  PinterestIcon,
  FacebookIcon,
  GooglePlusIcon,
  TumblrIcon,
  FacebookShareCount,
  GooglePlusShareCount,
  PinterestShareCount,
  TumblrShareCount,
} from 'react-share'

const styles = (theme) => ({
  root: {
    padding: 10,
  },
  socialIconWrapper: {
    margin: '0 4px',
    display: 'inline-block',
    '&:hover': {
      opacity: 0.7,
    },
    [theme.breakpoints.down('xs')]: {
      margin: '0 2px',
    },
  },
  count: {
    fontSize: '0.7em',
  },
  fontAwesomeIcon: {
    fontSize: '0.7em',
    transform: 'scale(1.1)',
  },
})

const SocialIcon = ({
  classes,
  shareBtn,
  icon,
  countIcon,
  fontAwesomeIcon,
  url,
  showBottomCounts,
  ...props
}) => {
  if (!shareBtn) {
    throw new Error('You must provide a ShareButton.')
  }
  if (!icon) {
    throw new Error('You must provide a social media icon.')
  }

  const ShareButton = shareBtn
  const Icon = icon

  const renderShareCount = ({ countIcon, ...props }) => {
    const Count = countIcon

    return (
      <Count {...props}>
        {(count) => {
          if (count === 0) {
            return <EyeIcon />
          }
          return count
        }}
      </Count>
    )
  }

  return (
    <div className={classes.socialIconWrapper}>
      <ShareButton style={{ cursor: 'pointer' }} url={url} {...props}>
        <Icon size={32} round />
      </ShareButton>
      {showBottomCounts && (
        <Fragment>
          {countIcon &&
            renderShareCount({
              countIcon,
              url,
              className: classes.count,
            })}
          {!countIcon && (
            <div className={classes.fontAwesomeIcon}>
              {renderShareCount({
                countIcon: EyeIcon,
              })}
            </div>
          )}
        </Fragment>
      )}
    </div>
  )
}

SocialIcon.propTypes = {
  shareBtn: PropTypes.any.isRequired,
  icon: PropTypes.any.isRequired,
  countIcon: PropTypes.any,
  fontAwesomeIcon: PropTypes.bool,
  url: PropTypes.string.isRequired,
  showBottomCounts: PropTypes.bool,
}

const ShareBar = ({
  classes,
  label,
  thumbnail,
  title,
  slug,
  showBottomCounts,
}) => {
  const pageUrl = 'https://healthfulinspired.com' + withPrefix(slug)

  return (
    <div style={{ width: '100%' }} className={classes.root}>
      <Typography
        align="center"
        variant="caption"
        style={{
          textTransform: 'uppercase',
          marginBottom: 5,
          fontWeight: 'bold',
        }}
      >
        {label || 'Share'}
      </Typography>
      <div style={{ textAlign: 'center' }}>
        <SocialIcon
          classes={classes}
          shareBtn={PinterestShareButton}
          description={title}
          url={pageUrl}
          media={thumbnail}
          icon={PinterestIcon}
          countIcon={PinterestShareCount}
          showBottomCounts={showBottomCounts}
        />
        <SocialIcon
          classes={classes}
          shareBtn={TwitterShareButton}
          icon={TwitterIcon}
          title={title}
          url={pageUrl}
          via="healthfulinspir"
          showBottomCounts={showBottomCounts}
        />
        <SocialIcon
          classes={classes}
          shareBtn={FacebookShareButton}
          icon={FacebookIcon}
          quote={title}
          url={pageUrl}
          countIcon={FacebookShareCount}
          showBottomCounts={showBottomCounts}
        />
        <SocialIcon
          classes={classes}
          shareBtn={GooglePlusShareButton}
          icon={GooglePlusIcon}
          url={pageUrl}
          countIcon={GooglePlusShareCount}
          showBottomCounts={showBottomCounts}
        />
        <SocialIcon
          classes={classes}
          shareBtn={TumblrShareButton}
          icon={TumblrIcon}
          url={pageUrl}
          countIcon={TumblrShareCount}
          showBottomCounts={showBottomCounts}
        />
      </div>
    </div>
  )
}

ShareBar.defaultProps = {
  showBottomCounts: true,
}

ShareBar.propTypes = {
  classes: PropTypes.object.isRequired,
  height: PropTypes.number,
  thumbnail: PropTypes.string,
  title: PropTypes.string,
  showBottomCounts: PropTypes.bool,
}

export default withStyles(styles, { withTheme: true })(
  onlyUpdateForKeys(['height'])(ShareBar),
)



// WEBPACK FOOTER //
// ./src/components/ShareBar.js